
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
   function flitsCustomIntregation(){
    var lion_integrated_page = Flits(".flits-custom-lion-page").children();
    var lion_integrated_page_mobile = Flits(".flits-custom-lion-page-mobile").children();
    Flits("#flits_tab_woofs-club .flits-box-card").append(lion_integrated_page);
    Flits("#flits_mobile_tab_woofs-club .flits-mobile-container-box").append(lion_integrated_page_mobile);
    
    Flits(".flits-custom-lion-page").remove();
    Flits(".flits-custom-lion-page-mobile").remove();
  }

  Flits(document).on('Flits:AccountPage:Loaded', function(event){  
    setTimeout(function(){
     flitsCustomIntregation(); 
    },2000);
       
  });
}(Flits));
